module.exports = __webpack_public_path__ + "f1772719ee8ca8dd8928a62540bd9ccb.png";